<div class="container-fluid">
  <div class="card mt-3">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-4">
          <div class="card-text">
            <div class="form-group" style="margin: 0;">
              <label class="control-label">{{'price-list.manage.priceListName' | translate}}</label>
              <div class="input-group input-group-sm">
                <input type="text" class="form-control {{ (priceListNameError ? 'is-invalid' : '') }}"
                  [(ngModel)]="priceList.name" placeholder="{{'price-list.manage.priceListName' | translate}}"
                  aria-label="Recipient's username" aria-describedby="button-addon2">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button"
                    (click)="updatePriceListName()">{{'price-list.manage.update'
                      | translate}}</button>
                </div>
                <div class="invalid-feedback">
                  {{priceListNameError | translate}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-4">
          <div class="form-group" style="margin: 0;">
            <label class="control-label">{{'price-list.manage.associatedEvent' | translate}}</label>
            <div class="input-group input-group-sm">
              <select class="form-control" [(ngModel)]="assignetEventId">
                <option *ngFor="let event of unAssignedApprovedEventsArray" [value]="event.value">{{event.label}}
                </option>
              </select>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                  (click)="updatePriceListAssociatedEvent()">{{'price-list.manage.update'
                    | translate}}</button>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="row">
        <div class="col">
          <ul ngbNav justify="end" #editorNav="ngbNav" (navChange)="beforeChange($event)">
            <li [ngbNavItem]="'products-tab'">
              <a ngbNavLink>{{ 'price-list.manage.products' | translate }}</a>
              <ng-template ngbNavContent>
                <app-add-product-form [productCategoryOptions]="productCategoryOptions" [priceList]="priceList" [eventCurrency]="eventCurrency"
                  [disableAddProductBtn]="disableAddProductBtn"></app-add-product-form>
                <app-products-table [priceList]="priceList" [productCategoryOptions]="productCategoryOptions" [eventCurrency]="eventCurrency"
                  (isProductEditMood)="getProductEditMood($event)"></app-products-table>
              </ng-template>
            </li>
            <li [ngbNavItem]="'categories-tab'">
              <a ngbNavLink>{{ 'price-list.manage.categories' | translate }}</a>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-4">
                    <form [formGroup]="productCategoryForm" (ngSubmit)="onProductCategorySubmit()"
                      class="needs-validation">
                      <div class="form-group mt-3" [formGroup]="productCategoryForm">
                        <label class="control-label">{{'price-list.manage.categoryName' | translate}}</label>
                        <div class="input-group input-group-sm">
                          <input type="text" class="form-control {{clientErrorArray['name'] ? 'is-invalid' : ''}}"
                            name="productCategoryName" id="productCategoryName" [required]="true" formControlName="name"
                            placeholder="{{'price-list.manage.categoryName' | translate}}">
                          <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="submit">{{'price-list.manage.add'
                                | translate}}</button>
                          </div>
                          <div class="invalid-feedback">
                            {{clientErrorArray['name'] | translate}}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <app-category-table [priceList]="priceList"></app-category-table>
              </ng-template>
            </li>
            <li [ngbNavItem]="'multiple-options-tab'">
              <a ngbNavLink>{{ 'price-list.manage.multipleOptions' | translate  }}</a>
              <ng-template ngbNavContent>
                <app-multiple-options-table [priceList]="priceList" (afterOptionsAdded)="onMultipleOptionsAdded()" [eventCurrency]="eventCurrency">
                </app-multiple-options-table>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="editorNav"></div>
        </div >
      </div>
    </div>
  </div>
</div>
